export default __webpack_public_path__ + "static/media/search.1d36a3eb.svg";